import React from 'react';
import { EVENT_TYPES } from '../data/mock';
import SectionHeading from './SectionHeading';

const EventTypes = () => {
  return (
    <section className="section-pad bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading
          eyebrow="For Every Celebration"
          title="One Coconut,"
          accent="Endless"
          tail="Memories"
          subtitle="Our customized coconuts add fun and tropical vibes to every kind of gathering."
        />

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {EVENT_TYPES.map((e, i) => (
            <article
              key={e.title}
              className="coco-card relative group rounded-3xl overflow-hidden shadow-soft border border-pink-100 bg-white"
              style={{ animationDelay: `${i * 80}ms` }}
              data-testid={`event-type-card-${e.title.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={e.image}
                  alt={e.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
                <div className="absolute bottom-6 left-6 right-6 text-white">
                  <div className="font-display font-bold text-2xl leading-tight">{e.title}</div>
                  <div className="text-sm text-white/90 font-script mt-1">{e.subtitle}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventTypes;
